// modules
import { createSelector } from 'reselect'

const caseManagers = (state) => state.admin.caseManagers

export const caseManagersList$ = createSelector(
  caseManagers,
  ({ caseManagersList }) => caseManagersList
)

export const caseManagersLoading$ = createSelector(
  caseManagers,
  ({ loading }) => loading
)

export const caseManagersModalLoading$ = createSelector(
  caseManagers,
  ({ modalLoading }) => modalLoading
)
